'use client'

import {useEffect, useRef} from 'react'
import {ExternalType, parseExternalLink} from '@/src/shared/utils/links'
import {isMobile} from '@/src/shared/utils/functions'

export const MobileStaticProvider = ({children}: React.PropsWithChildren) => {
  const reInitImageTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!isMobile()) return

    if (reInitImageTimeoutRef.current) {
      clearTimeout(reInitImageTimeoutRef.current)
      reInitImageTimeoutRef.current = null
    }

    reInitImageTimeoutRef.current = setTimeout(() => {
      for (const image of document.querySelectorAll('img')) {
        if (image.src) {
          image.src = parseExternalLink(ExternalType.Image, image.src)
        }
      }

      for (const link of document.querySelectorAll('a')) {
        if (link.href) {
          link.href = parseExternalLink(ExternalType.Link, link.href)
        }
      }
    }, 500)

    return () => {
      if (reInitImageTimeoutRef.current) clearTimeout(reInitImageTimeoutRef.current)
    }
  }, [])

  return children
}
